import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/vercel/path0/src/components/ds/Avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/vercel/path0/src/components/ds/badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/src/components/ds/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/vercel/path0/src/components/ds/card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/vercel/path0/src/components/ds/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Input"] */ "/vercel/path0/src/components/ds/input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/vercel/path0/src/components/ds/label.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/vercel/path0/src/components/ds/select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Switch"] */ "/vercel/path0/src/components/ds/switch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tag"] */ "/vercel/path0/src/components/ds/tag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Textarea"] */ "/vercel/path0/src/components/ds/textarea.tsx");
